import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import * as PropTypes from 'prop-types';
import classNames from 'classnames';
import { polyfill } from 'react-lifecycles-compat';
import { isFunction, isEqual } from '@utiljs/is';
import warning from 'warning';
import RadioGroup from './RadioGroup';
import RadioButtonGroup from './RadioButtonGroup';
import { connect } from './context';

var Radio = /*#__PURE__*/function (_React$Component) {
  _inherits(Radio, _React$Component);

  var _super = _createSuper(Radio);

  function Radio() {
    var _this;

    _classCallCheck(this, Radio);

    _this = _super.apply(this, arguments);
    _this.state = {
      checked: _this.initChecked
    };

    _this.handleRadioChange = function (event) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onChange = _this$props.onChange,
          value = _this$props.value,
          context = _this$props.context;

      if (disabled) {
        return;
      }

      event.persist();
      var _event$target = event.target,
          DOMChecked = _event$target.checked,
          nodeName = _event$target.nodeName,
          nodeType = _event$target.nodeType;

      var handleChange = function handleChange() {
        if (isFunction(onChange)) {
          onChange(_Object$assign(_Object$assign({}, event), {
            target: {
              checked: DOMChecked,
              nodeName: nodeName,
              nodeType: nodeType,
              type: 'radio',
              value: value
            }
          }));
        }
      }; // context 存在时，onChange 不区分非受控状态


      if (_this.props.checked !== undefined || context) {
        handleChange();
      } else {
        _this.setState({
          checked: DOMChecked
        }, handleChange);
      }

      if (context) {
        var onRadioGroupChange = context.onRadioGroupChange;
        onRadioGroupChange(value);
      }
    };

    return _this;
  }

  _createClass(Radio, [{
    key: "render",
    value: function render() {
      var _a = this.props,
          value = _a.value,
          defaultChecked = _a.defaultChecked,
          propsDisabled = _a.disabled,
          children = _a.children,
          className = _a.className,
          style = _a.style,
          context = _a.context,
          restProps = __rest(_a, ["value", "defaultChecked", "disabled", "children", "className", "style", "context"]);

      var simulateClx = classNames({
        'custom-radio': true
      }, className);
      var checked = this.state.checked;
      var disabled = context ? propsDisabled || context.disabled : propsDisabled;
      return /*#__PURE__*/React.createElement("label", {
        className: "roo-radio"
      }, /*#__PURE__*/React.createElement("input", _Object$assign({}, restProps, {
        type: "radio",
        className: "roo-radio-input",
        value: value,
        checked: checked,
        disabled: disabled,
        onChange: this.handleRadioChange,
        onClick: function onClick(e) {
          return e.stopPropagation();
        }
      })), /*#__PURE__*/React.createElement("span", {
        className: simulateClx,
        style: style
      }), /*#__PURE__*/React.createElement("span", null, children));
    }
  }, {
    key: "initChecked",
    get: function get() {
      var _this$props2 = this.props,
          context = _this$props2.context,
          checked = _this$props2.checked,
          defaultChecked = _this$props2.defaultChecked,
          value = _this$props2.value;

      if (context && context.value) {
        if (checked !== undefined) {
          warning(false, 'Roo Radio: 在 RadioGroup 内时，不支持单个 radio 设置 checked 和 defaultChecked, 请通过 Group 设置选中项');
        } // Radio value 支持字面量对象


        return isEqual(context.value, value);
      }

      if (checked !== undefined) {
        return checked;
      }

      return defaultChecked;
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, preState) {
      var checked = nextProps.checked;

      if (nextProps.context) {
        var value = nextProps.context.value;
        return {
          checked: isEqual(nextProps.value, value)
        };
      }

      if (checked !== undefined && checked !== preState.checked) {
        return {
          checked: nextProps.checked
        };
      }

      return null;
    }
  }]);

  return Radio;
}(React.Component);

Radio.rooName = 'RRadio';
Radio.propTypes = {
  defaultChecked: PropTypes.bool,
  // eslint-disable-next-line
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func
};
Radio.defaultProps = {
  defaultChecked: false,
  disabled: false,
  value: '',
  onChange: null
};
Radio.Group = RadioGroup;
Radio.ButtonGroup = RadioButtonGroup;
polyfill(Radio);
export default connect(Radio);